import { CheckCircleIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";

import type { ProjectPhaseForQuotaAssignment } from "~/modules/project/api/projectPhase/projectPhaseTypes.ts";

type Props = {
	isSelected?: boolean;
	onSelect: (phaseId: string) => void;
	phaseData: ProjectPhaseForQuotaAssignment;
};

const SelectableQuotaProjectPhase = ({
	isSelected,
	onSelect,
	phaseData,
}: Props) => {
	const isDisabled = phaseData.hasInvoice || phaseData.hasMultipleOrders;
	return <button type="button"
				   disabled={isDisabled}
				   className="group grid w-full grid-cols-[auto_1fr] rounded-lg text-sm hover:bg-gray-100"
				   onClick={() => onSelect(phaseData.id)}>
		<div className={clsx("flex w-10 flex-col items-center justify-center rounded-l-lg border",
			isSelected ? "border-success-600 bg-success-600 " : "border-gray-300")}>
			{isSelected ?
				<CheckCircleIcon className="size-6 text-white" /> :
				<div className="size-5 rounded-full border border-gray-300" />}
		</div>
		<div className="rounded-r-lg border border-l-0 border-gray-300">
			<div className="w-full px-4 py-3 text-left">{phaseData.phaseTitle}</div>
		</div>
	</button>;
};

export default SelectableQuotaProjectPhase;